import { Component, ElementRef, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { NotificationService } from '../aplication/api/Services/Notification.service';
import { NotificationDto } from '../aplication/api/Manipulate/Notification';
import { HourFormatService } from '../aplication/api/Infra/HourFormat.service';
import { ProcessDto } from '../aplication/api/Manipulate/ProcessDto';
import { ProcessosService } from '../aplication/api/Services/Process.service';
import { AIService } from '../aplication/api/Services/AI.service';
import { UserDto } from '../aplication/api/Manipulate/UserDto';
import { UserService } from '../aplication/api/Services/User.service';
import { ProcessHubService } from '../aplication/api/Services/Process.hub.service';
import { AnimationOptions } from 'ngx-lottie';
import { TenantsService } from '../aplication/service/tenants.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss']

})

export class AppTopBarComponent {
    showTimeWatches:boolean = false;
    theme: string = 'lara-light-purple';
    items!: MenuItem[];
    themechoose?:number;
    showNotification:boolean = false;
    listNotification: NotificationDto[] = [];
    arquivosUpload: FileUploadDto = new FileUploadDto();
    processes: ProcessDto[] = [];
    updating:boolean=false;
    credities: number = 0;
    userPicture!: string;
    form!: FormGroup;
    validChange:boolean = false;
    loaded:boolean = false
    loadedInit:boolean = false;
    showChangePasswordDialog:boolean = false;
    
    private _reloadInfo : any;
    public get reloadInfo() : any {
      return this._reloadInfo;
    }
    public set reloadInfo(v : any) {
      this._reloadInfo = v;

    }

    animationNotFound: AnimationOptions = {
      path: 'assets/Animations/animationNotFoundPages.json',
    };
    private _showDialogUserPreferences : boolean = false;
    public get showDialogUserPreferences() : boolean {
      return this._showDialogUserPreferences;
    }
    public set showDialogUserPreferences(v : boolean) {
      this._showDialogUserPreferences = v;
    }


    private _showDialogCredits : boolean = false;
    public get showDialogCredits() : boolean {
      return this._showDialogCredits;
    }
    public set showDialogCredits(v : boolean) {
      this._showDialogCredits = v;
    }


    private _usuario !: UserDto;
    public get usuario() : UserDto {
      return this._usuario;
    }
    public set usuario(v : UserDto) {
      this._usuario = v;
      if(v.interfaceMode){
        if(v.interfaceMode == 1){
          this.changeTheme('lara-light-purple', 'light');
        }else{
          this.changeTheme('lara-dark-purple', 'dark');
        }
      }
    }
    public shortInterval: any;
    public longInterval: any;
    public temasDisponiveis ?:Tema[];

    private _newProcessIdByStopwatch !: string;
    public get newProcessIdByStopwatch() : string {
      return this._newProcessIdByStopwatch;
    }
    public set newProcessIdByStopwatch(v : string) {
      this._newProcessIdByStopwatch = v;
      this._processService.GetMinimalById(v).subscribe(response => {
          this.modifyProcessByIdWithoutReload(response, v);
      });
    }

    private intervalNotifications:any;

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    constructor(
      public layoutService: LayoutService ,
      protected _userService:UserService,
      private _notificationService:NotificationService,
      protected _hourFormatService:HourFormatService,
      private _processService: ProcessosService,
      private _aiService: AIService,
      protected _messageService:MessageService,
      protected _tenantService:TenantsService,
      private _processHubService: ProcessHubService
    ) {
      this.setTheme();
      this.temasDisponiveis = [
        {label:'Light', value:'lara-light-purple', code:1},
        {label:'Dark', value:'lara-dark-purple', code:2},
      ]
     }
     ngOnInit() {
      setTimeout(() => {
        this.loadedInit = true;
      }, 100);
      this.GetUser();
      this.intervalNotifications = setInterval(() => {
        this.CreateNotifications();
      }, 6 * 60 * 1000);
      this.form = new FormGroup({
        password:  new FormControl('', [
          Validators.required,
          Validators.pattern(/^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/)
        ]),
      });
    }
    populateValues(){
      this.GetCredities()
      this.GenerateTimers();
      this.CreateNotifications();
    }
    logOut(){
      localStorage.clear();
      this._processHubService.stopConnection();
      window.location.reload();
    }

    changeTheme(theme: string, colorScheme: string) {
      const themeLink = <HTMLLinkElement>document.getElementById('theme-css');
      const newHref = themeLink.getAttribute('href')!.replace(this.layoutService.config.theme, theme);
      this.layoutService.config.colorScheme
      this.replaceThemeLink(newHref, () => {
          this.layoutService.config.theme = theme;
          this.layoutService.config.colorScheme = colorScheme;
          this.layoutService.onConfigUpdate();
      });
  }
  ShowDialogCredits(){
    this.showDialogCredits = !this.showDialogCredits;
  }
  ShowDialogUserPreferences(){
    this.showDialogUserPreferences = !this.showDialogUserPreferences;
  }

  GetUser(){
    this._userService.GetUser().subscribe(event=> {
      //console.log(event);
      this.usuario = event;
      if(this.usuario.profilePhoto){
        this.userPicture = `data:image/png;base64,${this.usuario.profilePhoto}`;
      }
      this.themechoose = this.usuario.interfaceMode;
    })
    this.loaded=true;
  }

  GetCredities(){
    this._aiService.GetCredities().subscribe(response=>this.credities = response);
  }

  GenerateTimers(){
    this._processService.ListByStatus(6).subscribe(result => {
      result.forEach(element => {
        if (!this.processes.find(x => x.id === element.id)) {
          this.processes.push(element);
        }
      });
      this.processes = this.processes.filter(process =>
        result.find(x => x.id === process.id)
      );
    });
  }
  public modifyProcessByIdWithoutReload(processModified: ProcessDto, id:string) {
    this.processes = this.processes.filter(x => x.id != id);
    if(processModified.status === 6){
      this.processes.push(processModified);
    }
  }
  ShowTimeWatches(){
    this.showNotification = false;
    this.showTimeWatches = !this.showTimeWatches
  }

  setTheme(){
    var theme = localStorage.getItem('theme')
    if(!theme){
      this.theme = 'lara-light-purple';
    }else{
      if(this.theme.includes('light')){
        this.changeTheme(this.theme, 'light');
      }else{
        this.changeTheme(this.theme, 'dark');
      }
    }
  }

  public mudarSenha(){
    const dto = this.usuario;
    var novaSenha = this.form.get('password')?.value;

    if(dto.id && novaSenha){
      this._tenantService.updatePassword(dto.id, novaSenha).subscribe(
        response=>{
          setTimeout(() => {
            this._messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Senha alterada com sucesso', life: 3000 });
            this.showChangePasswordDialog=false;
          }, 100);
        },
        error=> {
            console.error('Erro ao alterar senha', error);
        },
      );
    }
  }

  changeThemeCartsy(){
    //console.log(this.theme);

    if (this.themechoose == 1) {
      this.changeTheme('lara-light-purple', 'light');
      localStorage.setItem('theme', 'lara-light-purple');

    }else if (this.themechoose == 2) {
      this.changeTheme('lara-dark-purple', 'dark');
      localStorage.setItem('theme', 'lara-dark-purple');
    }
    // else{
    //   this.changeTheme('lara-light-purple', 'light');
    //   localStorage.setItem('theme', 'lara-light-purple');
    // }

    this.validChange = true;
  }


  RemoverNotificacao(id?:string){
    if(id)
    this._notificationService.delete(id).subscribe({
      next: (response) => {
        // this.listNotification = response;
      },
      error: (error) => {
        this.listNotification = this.listNotification.filter(x=>x.id != id);
        console.error('Erro ao listar notificações', error);
      },
      complete: () => {
        this.listNotification = this.listNotification.filter(x=>x.id != id);
      }
    });
  }
  ShowNotifications(event: Event) {
    this.showTimeWatches = false;
    this.showNotification = !this.showNotification;
  }
  CreateNotifications(){
    this._notificationService.register().subscribe({
      next: (response) => {
          // //console.log('Remoção bem-sucedida', response);
      },
      error: (error) => {
          console.error('Erro ao gerar notificações', error);
      },
      complete: () => {
        this._notificationService.list().subscribe({
          next: (response) => {
            response.forEach(element => {
              if (!this.listNotification.find(x => x.id === element.id)) {
                this.listNotification.push(element);
              }
            });
            this.listNotification = this.listNotification.filter(process =>
              response.find(x => x.id === process.id)
            );
          },
          error: (error) => {
              console.error('Erro ao listar notificações', error);
          },
          complete: () => {
              //console.log('Notificações geradas');
          }
        });
      }
    });
  }

  public onFileSelect(event: any) {
    //console.log('clicou');
    const selectedFiles: File[] = event.currentFiles;
    this.arquivosUpload.files = selectedFiles;
    this._messageService.add({ severity: 'info', summary: 'Imagem selecionada', detail: '' });
    this.validChange = true;
  }

  public AtualizarPreferencias() {
    this.updating = true;
    let formData = new FormData();

    if (this.arquivosUpload && this.arquivosUpload.files.length > 0) {
      formData.append('photo', this.arquivosUpload.files[0]);
    }
    // else{
    //   formData.append('photo', this.userPicture);
    // }
    if(this.themechoose){
      formData.append('interfaceMode', this.themechoose.toString());
    }

    this._userService.AtualizarPreferencias(formData).subscribe(
      response => {
        //console.log('Preferências atualizadas com sucesso', response);
        this._messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Preferências atualizadas com sucesso!' });
        setTimeout(() => {
          this.ShowDialogUserPreferences();
          this.updating = false;
          location.reload()
        }, 400);
      },
      error => {
        //console.log('Erro ao atualizar preferências', error);
        this._messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao atualizar preferências!' });
        setTimeout(() => {
          this.updating = false;
        }, 400);
      }
    );
  }

  replaceThemeLink(href: string, onComplete: Function) {
    const id = 'theme-css';
    const themeLink = <HTMLLinkElement>document.getElementById('theme-css');
    const cloneLinkElement = <HTMLLinkElement>themeLink.cloneNode(true);

    cloneLinkElement.setAttribute('href', href);
    cloneLinkElement.setAttribute('id', id + '-clone');

    themeLink.parentNode!.insertBefore(cloneLinkElement, themeLink.nextSibling);

    cloneLinkElement.addEventListener('load', () => {
        themeLink.remove();
        cloneLinkElement.setAttribute('id', id);
        onComplete();
    });
  }
  ngOnDestroy() {
    if(this.reloadInfo)
      clearTimeout(this.reloadInfo);
    if(this.intervalNotifications)
      clearInterval(this.intervalNotifications);
  }
  configMessager() {

  }
}

export interface FileUploadDto {
  [key: number]: any;
  fileName: string;
  fileSize: number;
}

export class FileUploadDto {
  files:File[] = [];
}

interface Tema{
  label:string;
  value:string;
  code:number;
}
